'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

const SSOButton = ({ ssoLink }: { ssoLink: string }) => {
  const router = useRouter();

  useEffect(() => {
    router.push(ssoLink);
  }, [ssoLink]);

  return (
    <div className="flex h-[calc(100vh-48px)] items-center justify-center overflow-y-auto rounded-3xl bg-white">
      <div className="flex h-full w-full items-center justify-center">
        <div className="loader"></div>
      </div>
    </div>
  );
};
export default SSOButton;
